<template>
    <div class="publicWelfare">
        <div >
            <Cascader :data="areaData" v-model="value1" @on-change="handleChange" style="width: 300px;display: inline-block;margin-right: 20px" placeholder="地区选择"></Cascader>
            <Select v-model="model" style="width:200px;display: inline-block" :clearable="close" @on-change="caseCase" placeholder="案件类型选择">
                <Option v-for="item in causeOfActionData" :value="item.value" :key="item.value" >{{ item.label }}</Option>
            </Select>
        </div>
        <table class="formtable">
            <thead>
            <tr>
                <th>类型</th>
                <th>佣金</th>
                <th>地区</th>
                <th>联系人</th>
                <th>电话</th>
                <th>件数</th>
                <!--<th>操作</th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-for="(value,index) in listData">
                <td>{{value.tname}}</td>
                <td>{{value.money}}</td>
                <td>{{value.provinceName}}-{{value.cityName}}<span v-if="value.areaName">-{{value.areaName}}</span></td>
                <td>{{value.linkman}}</td>
                <td>{{value.linkmanMobile}}</td>
                <td>
                    <InputNumber :max="99999999" :min="1" :step="1" v-model="value.count" @on-change="onNumber(value.count,value.caseId)"></InputNumber>
                </td>
                <!--<td> <Button>修改</Button></td>-->
            </tr>
            </tbody>
        </table>
        <Page :total="count" show-elevator @on-change="page = $event;countUserDay()" :page-size="pageSize"/>
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
</template>

<script>
    export default {
        name: "CaseInfoList",
        data() {
            return {
                close : true,
                pageSize: 15,
                page: 1,
                provinceName: '',
                cityName: '',
                AreaName: '',
                typeId: '',
                listData : [],
                value1: [],
                areaData : [],
                causeOfActionData : [],
                model: '',
                userId  : '10979',
                count : 0,
                spinShow : false,
            }
        },
        mounted () {
            this.countUserDay()
            this.address()
            this.causeOfAction()
        },
        methods : {
            onNumber : function(count,caseId){
                var _this = this
                _this.spinShow = true
                _this.countData = count
                _this.caseId = caseId
                _this.send({
                    server : 'ai',
                    data:{caseId:caseId,count:count,userId:_this.userId},
                    url : '/CaseManage',
                    success: function (res) {
                        if(res.status){
                            _this.$Message.success('操作成功');
                        }
                        _this.spinShow = false
                    }
                })
            },
            handleChange : function(value, selectedData){
                var _this = this
                console.log(selectedData[0])
                if(selectedData[0] == undefined){
                    _this.provinceName = ''
                    _this.cityName = ''
                    _this.AreaName = ''
                }else {
                    _this.provinceName = selectedData[0].label
                    _this.cityName = selectedData[1].label
                    _this.AreaName = selectedData[2].label
                }
                _this.listData = [],
                _this.page = 1,
                _this.countUserDay()
            },
            countUserDay : function () {
                var _this = this
                _this.spinShow = true
                _this.send({
                    server : 'ai',
                    data:{userId: _this.userId,pageSize: _this.pageSize, page: _this.page, provinceName:_this.provinceName, cityName:_this.cityName, AreaName:_this.AreaName,typeId: _this.typeId},
                    url : '/CaseInfoList',
                    success: function (res) {
                        _this.spinShow = false
                        _this.listData = res.data.list
                        _this.count = res.data.count
                    }
                })
            },
            causeOfAction : function(){
                var _this = this
                _this.send({
                    server : 'ai',
                    data:{},
                    url : '/CaseType',
                    success: function (res) {
                        console.log(res)
                        for(var i in res.data){
                            _this.causeOfActionData.push({value:res.data[i].typeId,label:res.data[i].tname})
                        }
                    }
                })
            },
            caseCase : function(e){
                console.log(e)
                var _this = this
                _this.listData = [],
                _this.page = 1,
                _this.typeId = e
                _this.countUserDay()
            },
            address : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    data:{},
                    url : '/AreaList',
                    success: function (res) {
                        // areaData
                        var data = []
                        for(var i in res.data){
                            data.push(res.data[i])
                        }
                        convertTree(data)
                        function convertTree(tree) {
                            const result = []
                            tree.forEach((item) => {
                                // 解构赋值
                                let {
                                    AreaId: value,
                                    AreaName: label,
                                    list: children
                                } = item
                                if (children) {
                                    children = convertTree(children)
                                }
                                result.push({
                                    value,
                                    label,
                                    children
                                })
                            })
                            _this.areaData = result
                            return result
                        }
                        console.log(_this.areaData)
                    }
                })
            },

        },
    }
</script>

<style scoped>
    .publicWelfare table {font-family: Consolas,Menlo,Courier,monospace;font-size: 12px;border-collapse: collapse;border-spacing: 0;empty-cells: show;border: 1px solid #e9e9e9;width: 100%;margin-bottom: 24px;}
    .formtable {font-family: Consolas,Menlo,Courier,monospace;font-size: 12px;border-collapse: collapse;border-spacing: 0;empty-cells: show;border: 1px solid #e9e9e9;width: 100%;margin-bottom: 24px;}
    .publicWelfare table th {background: #f7f7f7;white-space: nowrap;color: #5c6b77;font-weight: 600;}
    .publicWelfare table td, .publicWelfare table th {border: 1px solid #e9e9e9;padding: 8px 16px;text-align: left;}
    .details p{color: #000000}
    .details span{color: #5c6b77}
</style>
